import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

// Default content (fallback when CMS is empty)
const defaultContent = {
  hero: {
    title: "Begin Your Hospitality Journey",
    subtitle: "Join Uttarakhand's Premier Hotel Management Institute",
    tagline: "7000+ Students Placed in Top Hotels",
    backgroundImage: "/images/students/taj/taj-hero.webp"
  },
  contact: {
    phone: "+91 7055547000",
    email: "admissions.raminstitute@gmail.com",
    address: "Shri Ram Institute of Hotel Management, Rajpur Road, Dehradun, Uttarakhand 248001",
    whatsapp: "+917055547000",
    mapLink: "https://maps.google.com/?q=Shri+Ram+Institute+Dehradun"
  },
  stats: {
    studentsPlaced: "7000+",
    yearsExperience: "25+",
    partnerHotels: "100+",
    campusSize: "2 Acres"
  },
  about: {
    established: "1999",
    description: "Shri Ram Institute of Hotel Management is one of the leading hotel management colleges in Uttarakhand, shaping future hospitality leaders since 1999."
  },
  courses: {
    sectionTitle: "Choose Your Career Path",
    sectionSubtitle: "Degree & Diploma programs approved from State Govt. University with 100% placement assistance",
    scholarshipText: "3 Crores Scholarships for Aspiring Students",
    scholarshipSubtext: "Upto 100% Scholarship for Meritorious Students",
    items: [
      {
        id: "certificate",
        name: "Certificate Courses",
        duration: "6 Months - 1 Year",
        description: "Professional courses with practical training:",
        eligibility: "10th Pass",
        specializations: ["Culinary Arts", "Bakery", "Bartending", "Food Production"]
      },
      {
        id: "diploma",
        name: "Diploma in Hotel Management (DHM)",
        duration: "1 Year",
        description: "Comprehensive diploma covering hospitality basics, front office, F&B service, and housekeeping.",
        eligibility: "10+2 Pass"
      },
      {
        id: "bachelor",
        name: "Bachelor of Hotel Management (BHM)",
        duration: "4 Years",
        description: "Degree program approved from State Govt. University with industrial training and 5-star hotel placements.",
        eligibility: "10+2 Pass (Any Stream)"
      },
      {
        id: "master",
        name: "Master of Hotel Management (MHM)",
        duration: "2 Years",
        description: "Advanced program for hospitality professionals focusing on management and leadership roles.",
        eligibility: "Bachelor's Degree"
      }
    ]
  },
  testimonials: {
    sectionTitle: "What Our Alumni & Industry Say",
    sectionSubtitle: "Hear from our graduates working across the globe and industry recruiters",
    facebookRating: "4.9/5",
    googleRating: "4.9/5",
    placementRate: "97.2%",
    happyAlumni: "5000+",
    items: [
      {
        id: 1,
        name: "Prabhdeep Singh",
        role: "Hospitality Professional",
        company: "Ribs & Burgers, Sydney, Australia",
        image: "https://raminstitute.in/wp-content/uploads/2021/07/Prabhdeep-Singh.webp",
        quote: "Shri Ram Institute of Hotel Management, Dehradun is one of the best hospitality management colleges in India where in you will be moulded into the complete hospitality professional.",
        rating: 5,
        type: "Alumni"
      },
      {
        id: 2,
        name: "Ravi Rawat",
        role: "Hospitality Professional",
        company: "Rickys All Day Grill, Alberta, Canada",
        image: "https://raminstitute.in/wp-content/uploads/2021/07/Ravi-Rawat.webp",
        quote: "I had a great experience studying at Shri Ram Institute of Hotel Management, Dehradun. I enjoyed every moment in the college and learnt a lot here.",
        rating: 5,
        type: "Alumni"
      },
      {
        id: 3,
        name: "Vishal Virmani",
        role: "Hotel Manager",
        company: "The Oberoi",
        image: "https://raminstitute.in/wp-content/uploads/2021/07/oberoi.webp",
        quote: "Highly professional and groomed students. Ram Institute of Hotel Management Dehradun imparts quality education and practical, which is evident during the students training with our hotel.",
        rating: 5,
        type: "Industry"
      }
    ]
  },
  videos: {
    sectionTitle: "Watch Our Videos",
    items: [
      { id: "3y11-xMm2BU", title: "Student Placement Journey", isShort: false },
      { id: "LqSPWXBQmdw", title: "Campus Life & Training", isShort: false },
      { id: "WYk5yPHy-kw", title: "Industry Exposure", isShort: false },
      { id: "xvqNY--zMIQ", title: "Student Testimonial", isShort: true }
    ]
  },
  tajRambagh: {
    sectionTitle: "Taj Rambagh Palace",
    sectionSubtitle: "World's No.1 Rated Hotel",
    students: [
      { id: 1, image: "/images/students/taj/taj-rambagh-palace-1.webp", alt: "Chef at Taj Rambagh Palace Dining" },
      { id: 2, image: "/images/students/taj/taj-club.webp", alt: "Student at Taj Club" },
      { id: 3, image: "/images/students/taj/monika-taj.webp", alt: "Monika - Taj Hotels" },
      { id: 4, image: "/images/students/taj/taj-rambagh-palace-2.webp", alt: "Student at Taj Rambagh Palace Garden" },
      { id: 5, image: "/images/students/taj/taj-rambagh-group.webp", alt: "Taj Rambagh Palace Group Photo", featured: true },
      { id: 6, image: "/images/students/taj/amit-giri-taj.webp", alt: "Amit Giri - Taj Rambagh Jaipur" },
      { id: 7, image: "/images/students/taj/taj-selection.webp", alt: "Certificate Presentation - Taj Selection" },
      { id: 8, image: "/images/students/taj/taj-udaipur.webp", alt: "Student - Taj Udaipur" },
      { id: 9, image: "/images/students/taj/chandra-taj-devi-ratan.webp", alt: "Chandra - Taj Devi Ratan" }
    ]
  },
  oberoi: {
    sectionTitle: "The Oberoi's",
    sectionSubtitle: "Luxury Hospitality Excellence",
    students: [
      { id: 1, image: "/images/students/oberoi/oberoi-rajvilas.webp", alt: "Oberoi Rajvilas Jaipur" },
      { id: 2, image: "/images/students/oberoi/amisha-oberoi-gurugram.webp", alt: "The Oberoi Gurugram" },
      { id: 3, image: "/images/students/oberoi/kajal-oberoi-sukhvillas.webp", alt: "Kajal - Oberoi Sukhvillas", featured: true },
      { id: 4, image: "/images/students/oberoi/jigme-oberoi-sukhvillas.webp", alt: "Oberoi Sukhvillas" },
      { id: 5, image: "/images/students/oberoi/oberoi-udai-vilas.webp", alt: "Oberoi Udai Vilas" }
    ]
  },
  hotelLogos: {
    hotels: [
      { name: "Taj Hotels", textLogo: "TAJ", count: "1000+" },
      { name: "ITC Hotels", textLogo: "ITC", count: "300+" },
      { name: "Hyatt", textLogo: "HYATT", count: "300+" }
    ]
  }
};

const CMSContext = createContext();

export const CMSProvider = ({ children }) => {
  const [content, setContent] = useState(defaultContent);
  const [loading, setLoading] = useState(false); // Start false - render immediately with defaults

  useEffect(() => {
    const timer = setTimeout(() => {
      loadCMSContent();
      loadIntegrations();
    }, 100);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadCMSContent = async () => {
    try {
      const sections = ['hero', 'contact', 'stats', 'about', 'courses', 'testimonials', 'videos', 'tajRambagh', 'oberoi', 'hotelLogos'];
      const responses = await Promise.all(
        sections.map(section => 
          axios.get(`${API_URL}/api/cms/${section}`).catch(() => ({ data: { section, content: null } }))
        )
      );

      const newContent = { ...defaultContent };
      responses.forEach(res => {
        if (res.data && res.data.content) {
          // Merge with defaults (so missing fields don't break UI)
          newContent[res.data.section] = {
            ...defaultContent[res.data.section],
            ...res.data.content
          };
        }
      });

      setContent(newContent);
    } catch (error) {
      console.error("Error loading CMS content:", error);
      // Keep defaults on error
    } finally {
      setLoading(false);
    }
  };

  const loadIntegrations = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/integrations/public`);
      if (response.data) {
        // Initialize GA4 (Google Analytics 4) first
        if (response.data.ga4MeasurementId && window.initGA4) {
          window.initGA4(response.data.ga4MeasurementId);
        }
        // Initialize Google Ads if ID is configured
        if (response.data.googleAdsId && window.initGoogleAds) {
          window.initGoogleAds(response.data.googleAdsId, response.data.googleAdsConversionLabel);
        }
        // Initialize Meta Pixel if ID is configured
        if (response.data.metaPixelId && window.initMetaPixel) {
          window.initMetaPixel(response.data.metaPixelId);
        }
      }
    } catch (error) {
      console.error("Error loading integrations:", error);
    }
  };

  const refreshContent = () => {
    loadCMSContent();
    loadIntegrations();
  };

  return (
    <CMSContext.Provider value={{ content, loading, refreshContent }}>
      {children}
    </CMSContext.Provider>
  );
};

export const useCMS = () => {
  const context = useContext(CMSContext);
  if (!context) {
    throw new Error("useCMS must be used within a CMSProvider");
  }
  return context;
};

export default CMSContext;
